// React
import { Fragment, useContext } from "react"

// Components
import { BaseTable, CommandButton, Modal, ProductInventory, TableHeader } from "components"
import { Loading } from "components/feedbacks"

// Contexts
import { DataContext } from "../contexts"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

// Types
import type { IngredientDataType } from "../types"
import type { FormType } from "../utils"

// Utils
import { convertNumber, useToggle, useCoaByCode } from "utils"

export function Journal(): JSX.Element {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <CommandButton
        actiontype="journal"
        onClick={toggle}
      />

      <Modal isOpen={isActive} title="JOURNAL" closeModal={toggle} size="full">
        <Modal.Body>
          <JournalTable />
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

function JournalTable() {
  // Hooks
  const { ingredient, product } = useContext(DataContext)

  // Form
  const { control } = useFormContext<FormType>()
  const qty_build_unit = useWatch({
    control,
    name: "qty_build_unit"
  })

  const overhead = useWatch({
    control,
    name: "overhead"
  })

  const transaction_date = useWatch({
    control,
    name: "transaction_date"
  })
  const trx_code = useWatch({
    control,
    name: "trx_code"
  })
  const date_value: string = moment(transaction_date).format("DD/MM/YYYY")

  // Functions
  const getTotal = (item: IngredientDataType): number => {
    return item.avg_price * item.qty * qty_build_unit
  }

  // Vars
  const total = ingredient.reduce((acc, item) => {
    return acc + getTotal(item)
  }, 0)

  return (
    <BaseTable>
      <TableHeader>
        <tr>
          <th>DATE</th>
          <th>IDM</th>
          <th>ACCOUNT</th>
          <th>DEBET</th>
          <th>CREDIT</th>
        </tr>
      </TableHeader>

      <tbody>
        {total + overhead > 0 && (
          <tr>
            <td>{date_value}</td>
            <td>{trx_code}</td>
            <ProductInventory product_id={product.product_id.toString()} />
            <td>{convertNumber(Math.round(total + overhead)).intoCurrency}</td>
            <td></td>
          </tr>
        )}


        {overhead > 0 && (
          <tr>
            <td>{date_value}</td>
            <td>{trx_code}</td>
            <OverheadItem link_code={'LA13'} />
            <td></td>
            <td>{convertNumber(overhead).intoCurrency}</td>
          </tr>
        )}

        {ingredient.filter((item) => getTotal(item) > 0).map((item, key) => {
          // Vars
          const total: number = getTotal(item)

          return (
            <tr key={key}>
              <td>{date_value}</td>
              <td>{trx_code}</td>
              <ProductInventory product_id={item.product_id.toString()} />
              <td></td>
              <td>{convertNumber(Math.round(total)).intoCurrency}</td>
            </tr>
          )
        })}
      </tbody>
    </BaseTable>
  )
}

function OverheadItem(params: {
  link_code: string
}) {
  // Hooks
  const { data, isLoading } = useCoaByCode(params.link_code)

  if (isLoading) {
    return (
      <td>
        <Loading loading />
      </td>
    )
  }

  return <td>{data}</td>
}